
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refleksi-kompetensi/asesmen-refleksi/[competency]",
      function () {
        return require("private-next-pages/refleksi-kompetensi/asesmen-refleksi/[competency].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refleksi-kompetensi/asesmen-refleksi/[competency]"])
      });
    }
  